export default "__VITE_ASSET__B95e65Hk__"